"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import CiInteractiveMap, {ciInteractiveMapMarkers,} from "@/components/site-officiel/accueil/ci-interactive-map";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Nos Régions"}
        backgroundImgSrc={"/images/card-title/Nos-Regions.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>Nos Régions</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Présentation */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"L' OUEST : SEULE LA NATURE REGNE"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          Le parc national de Taï , réserve de biosphère depuis 1977 et inscrite
          au patrimoine mondial de l’UNESCO depuis 1982, mérite le détour.
          L’époustouflante végétation encore vierge riche de sa biodiversité
          abrite des espèces animales exceptionnelles dont certaines douées
          d’une intelligence surprenante (Chimpanzé).
          <br />
          <br />
          Les Dans, peuple autochtone de la région chez qui, subsiste les «
          êtres sacrés », représentés pas une diversité de masques ; chanteurs
          (généralement ornés de clochettes), griots, de guerre, danseurs,
          sacrés. Ils expriment la majesté, la sagesse, le mystère des forces
          surnaturelles qui les animent. Ils sont chargés de montrer
          l’invisible. Ils interviennent dans des cérémonies bien particulières,
          rites de passage, purification, sacrifice, initiation, conjuration…
          <br />
          <br />
          <span className="font-bold">« Ecotourisme & Société secrète » </span>
        </AwesomeCard>
      </SectionPage>

      {/* galerie */}
      <SectionPage sectionType="2xl">
        <AwesomeCard className={"bg-white"} titleClassName={"text-bleu-marine"}>
          <div className={'mt-8'}>
            <ImageGallery images={
              Array.from({ length: 4 }).map((_, index) => ({
                src: `/images/nos-regions/ouest${index + 1}.jpg`,
                alt: `image${index + 1}`,
                width: 700,
                height: 700,
              }))
            } aspectRatio={"video"} />
          </div>
        </AwesomeCard>
      </SectionPage>

      {/* Villes et Régions */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Villes et Régions"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          <div className={"flex justify-center w-full"}>
            <CiInteractiveMap
              strokeColor={"#ffffff"}
              markers={ciInteractiveMapMarkers(navigate)}
            />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
